type Step = 'email' | 'verify' | 'reset';

interface PasswordResetHeaderProps {
  currentStep: Step;
  className?: string;
}

const stepInfo = {
  email: {
    title: '비밀번호 재설정',
    subtitle: '이메일 주소를 입력해주세요',
    stepNumber: 1
  },
  verify: {
    title: '인증번호 확인',
    subtitle: '이메일로 발송된 인증번호를 입력해주세요',
    stepNumber: 2
  },
  reset: {
    title: '새 비밀번호 설정',
    subtitle: '새로운 비밀번호를 입력해주세요',
    stepNumber: 3
  }
};

export function PasswordResetHeader({ 
  currentStep,
  className = '' 
}: PasswordResetHeaderProps) {
  const info = stepInfo[currentStep];
  
  return (
    <div className={`text-center mb-10 ${className}`}>
      {/* 단계 표시 */}
      <div className="flex justify-center items-center mb-6">
        <div className="flex items-center space-x-4">
          {[1, 2, 3].map((step) => (
            <div key={step} className="flex items-center">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${
                step === info.stepNumber
                  ? 'bg-[#51C854] text-white'
                  : step < info.stepNumber
                  ? 'bg-green-200 text-green-800'
                  : 'bg-gray-200 text-gray-500'
              }`}>
                {step < info.stepNumber ? (
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                ) : (
                  step
                )}
              </div>
              {step < 3 && (
                <div className={`w-12 h-0.5 ${
                  step < info.stepNumber ? 'bg-green-200' : 'bg-gray-200'
                }`} />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* 제목과 설명 */}
      <h1 className="text-[28px] font-bold text-[#222222] mb-3">{info.title}</h1>
      <p className="text-[16px] text-gray-600">{info.subtitle}</p>
    </div>
  );
}